import { render, staticRenderFns } from "./TheadRibbonsBalances.vue?vue&type=template&id=d87af486"
import script from "./TheadRibbonsBalances.vue?vue&type=script&lang=js"
export * from "./TheadRibbonsBalances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports